import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';

import { Dialog } from '@mui/material';
import { varFadeInUp } from './variants';

const DialogAnimate = (props) => {
  const { animate = varFadeInUp, children, open = false, onClose, ...other } = props;

  return (
    <AnimatePresence>
      {open && (
        <Dialog open={open} PaperComponent={motion.div} PaperProps={{ ...animate }} onClose={onClose} {...other}>
          {children}
        </Dialog>
      )}
    </AnimatePresence>
  );
};

DialogAnimate.propTypes = {
  animate: PropTypes.object,
  children: PropTypes.node.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func
};

export default DialogAnimate;
